import { RouteConfig } from 'vue-router';
import Breadcrumbs from './breadcrumbs';

const Home = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Home" */ '@/pages/Home/Home');
const OpenDataPolicy = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "OpenDataPolicy" */ '@/pages/OpenDataPolicy/OpenDataPolicy');
const NewRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "NewRequest" */ '@/pages/NewRequest/newRequest');
const RequestSuccess = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RequestSuccess" */ '@/pages/RequestSuccess/requestSuccess');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      breadcrumb: Breadcrumbs.home,
    },
  },
  {
    path: '/policy',
    name: 'OpenDataPolicy',
    component: OpenDataPolicy,
    meta: {
      breadcrumb: Breadcrumbs.openDataPolicy,
    },
  },
  {
    path: '/request',
    name: 'RequestAdditionalDataPage',
    component: NewRequest,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.request,
    },
  },
  {
    path: '/request-success',
    name: 'RequestSuccessPage',
    component: RequestSuccess,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.request,
    },
  },
];

export default routes;
